import { Text } from '@zillow/constellation-10';

type Props = {
  numerator: number;
  denominator: number;
};

export const CharacterCounter = ({ numerator, denominator }: Props) => {
  return (
    <Text
      className="noPrint"
      textStyle="fineprint"
      css={{ color: numerator > denominator ? 'red.600' : 'text.subtle' }}
    >{`${numerator}/${denominator}`}</Text>
  );
};
